import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store';
import {initGlobalFilters} from "./shared/filters";

Vue.config.productionTip = false

initGlobalFilters(Vue);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
})
.$mount('#app')
